import styled from "@emotion/styled";
import { colors, customScroll, media, pxtorem } from "../../../assets/styles/theme";
import  tableListRightBottomBg from "../../../assets/images/tableListRightBottomBg.svg";

export const TableListStyled = styled('div')`
    position: relative; 
    &:after {
        content: '';
        position: absolute;
        width: 190px;
        height: 190px;        
        right: -20px;
        bottom: -35px;
        z-index: -1;
        background-image: url(${tableListRightBottomBg});
        background-position: 3px 12px;
        background-repeat: no-repeat;        
    }
    .tableColumn {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: ${colors.primaryDark};
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        height: 60px;
    } 
    .MuiTableContainer-root {
        background-color: ${colors.white};
    }
    .MuiTablePagination-root {
        background-color: ${colors.gray};
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        border-top: solid 3px ${colors.white};
        .MuiToolbar-root {
            min-height: 32px;
            height: 32px;
        }
        .MuiButtonBase-root {
            padding-top: 2px;
            padding-bottom: 2px;
        }
        .MuiTablePagination-selectLabel, 
        .MuiTablePagination-displayedRows, .MuiSelect-select {
            font-size: ${pxtorem(12)};
            color: ${colors.primaryDark};
            letter-spacing: .28px;
        }
       
        .MuiInputBase-root {
            .MuiSelect-select {
                padding-left: 5px;
                margin-left: -7px;                
            }                
            .MuiSvgIcon-root {                
                color:  ${colors.primaryDark};
            }
        }
        .MuiTablePagination-actions {            
            color:  ${colors.primaryDark};
            .MuiButtonBase-root{
                width: 30px;
                height: 30px;
            }            
        }
    }
    .MuiButtonBase-root.Mui-disabled img, .MuiButtonBase-root[disabled] img {
        opacity :.5 ;
    }
    .searchWrapper {
        position: relative;
        margin-right: 15px;
        ${media.mmd`
            max-width: 180px;
            margin-right: 5px;
        `}
    }
    ${media.mmd`
        .lblAssignClients {
            line-height: 1;
        }
        .btn-export-table-data {
            line-height: .8;
        }
    `}
    
    .customTableInputSearch {
        margin-right: 20px;
        
        .MuiFormLabel-root {
            color: ${colors.darkestWhite};  
            background-color: transparent !important;
            transform: translate(0, -1.5px) scale(1) !important;
        }
        
        .MuiInputBase-root {
            min-width: 214px;
            color: ${colors.lightWhite};  
            font-size: ${pxtorem(13)};
            ${media.mmd`
                min-width: 180px;
                margin-right: 10px;
            `}
            
            &:before {
                border-bottom-color: ${colors.darkierWhite}; 
            }
            .MuiInputBase-input {
                padding-right: 30px;
            }
            .MuiInputBase-input::placeholder {
                color: ${colors.lightWhite};
                opacity: 1;
            }
        }
    }
    .iconGlobalClear {
        position: absolute;
        right: 0;
        top: 14px;
        cursor: pointer;
        svg {
            fill: ${colors.white};
            font-size: ${pxtorem(20)};
        }
    }
    .customTableGroup {
        .MuiFormLabel-root {
            color: ${colors.darkestWhite};             
            font-size: ${pxtorem(13)};
        }
        .MuiInputBase-root {
            color: ${colors.lightWhite};  
            font-size: ${pxtorem(13)};
            &:before {
                border-bottom-color: ${colors.darkierWhite}; 
            }
        }
        .MuiSvgIcon-root {
            fill: ${colors.lightWhite}; 
        }
    }

    /* table container */
    .MuiTableContainer-root {
        ${customScroll};
    }
    /* table header */
    .MuiTableCell-head {
        font-size: ${pxtorem(13)};
        font-weight: 600;
        padding: 8px;
        .MuiButtonBase-root {
            padding: 0;
        }
        .MuiIconButton-root {
            width: 24px;
            height: 24px;
            margin-left: 3px;
            margin-right: -2px;
            img {
                width: 13px;
                height: 13px;
            }
        }
        .MuiTableSortLabel-icon {
            height: 16px;
            color: rgba(0, 0, 0, 0.56) !important;
        }       
    }
    /* table body cell*/
    .MuiTableCell-body {
        padding: 6px 8px;
        height: 40px;
        font-size: ${pxtorem(13)};       
    }   

     /* inner table row */
     .MuiTableCell-body .flex.items-center{
        margin: -12px -8px -12px -8px;
        display: flex;
        align-items: center;
        strong {
            margin-top: 2px;
        }
     }
     .MuiTableRow-root {
        &:hover .MuiTableCell-body{
            background-color: ${colors.lightGray} !important;
        }
        .MuiTableCell-root {
            border-bottom: solid 1px ${colors.borderColor};
        }
       
     }
    .MuiTableRow-root .MuiTableCell-root .MuiCollapse-root {
        margin: -14px -8px;
    }

    /* switch style */
    .platformStatusSwitch {
        margin-top: -6px;
        margin-bottom: -6px;
    }
    .assignStatusSwitch {
        margin-top: -6px;
        margin-bottom: -6px;
        .MuiSwitch-track {
            background-color: #354966;
            opacity: 1;
        }
        .Mui-checked+.MuiSwitch-track {
            background-color: ${colors.primaryMain};
            opacity: .5;
        }
    }
    /* filter button */
    .btn-clearfilter{
        border-color: ${colors.white};
        color: ${colors.white};
        margin-left: 10px;
        &:hover {
            color: ${colors.secondaryContrastText};
            border-color: ${colors.secondaryDark};            
            background-color: ${colors.secondaryDark};
        }
    }
    .noRecords {
        &:hover td.MuiTableCell-body{
            background-color: ${colors.white} !important;            
        }
        td.MuiTableCell-body{
            border-bottom: none;
        }
    }
     
`;